// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ResourcesSectionOne {
  width: 100%;
  background: rgb(249, 249, 249);
  color: #000000;
  display: flex;
  flex-direction: column;
  position: relative;
  font-size: 18px;
  padding: 80px 175px;
  margin-top: 50px;
}
.ResourcesSectionOne .ResourcesSectionOne-header {
  font-family: Roboto;
  font-style: normal;
  font-weight: 400;
  font-size: 43px;
  line-height: 1.3;
  color: #1c2640;
  margin-bottom: 30px;
}
.ResourcesSectionOne .ResourcesSectionOne-sub-header {
  font-size: 18px;
  font-weight: 400;
  line-height: 1.6;
  color: #1c2640;
  width: 100%;
}
.ResourcesSectionOne .ResourcesSectionOne-cards-list {
  display: flex;
  flex-direction: column;
  margin-top: 40px;
}
.ResourcesSectionOne .ResourcesSectionOne-cards-list .ResourcesSectionOne-cards-list-row {
  display: flex;
  flex: 1 1;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 20px;
}
.ResourcesSectionOne .ResourcesSectionOne-cards-list .ResourcesSectionOne-cards-list-row a {
  display: flex;
  flex-direction: column;
  width: 31.5%;
  background-color: #000000;
  border-radius: 15px;
  padding: 30px;
  transition: all 0.3s ease 0s;
}
.ResourcesSectionOne .ResourcesSectionOne-cards-list .ResourcesSectionOne-cards-list-row a.one {
  height: 250px;
  position: relative;
  background-color: #2c95dd;
}
.ResourcesSectionOne .ResourcesSectionOne-cards-list .ResourcesSectionOne-cards-list-row a.one img {
  right: 20px;
}
.ResourcesSectionOne .ResourcesSectionOne-cards-list .ResourcesSectionOne-cards-list-row a.two {
  height: 350px;
  position: relative;
  background-color: #f84144;
}
.ResourcesSectionOne .ResourcesSectionOne-cards-list .ResourcesSectionOne-cards-list-row a.two img {
  right: 20px;
}
.ResourcesSectionOne .ResourcesSectionOne-cards-list .ResourcesSectionOne-cards-list-row a.three {
  height: 250px;
  position: relative;
  background-color: #173a87;
}
.ResourcesSectionOne .ResourcesSectionOne-cards-list .ResourcesSectionOne-cards-list-row a.three img {
  right: 20px;
}
.ResourcesSectionOne .ResourcesSectionOne-cards-list .ResourcesSectionOne-cards-list-row a.four {
  margin-top: -85px;
  height: 350px;
  position: relative;
  background-color: #27ad60;
}
.ResourcesSectionOne .ResourcesSectionOne-cards-list .ResourcesSectionOne-cards-list-row a.four img {
  right: 20px;
}
.ResourcesSectionOne .ResourcesSectionOne-cards-list .ResourcesSectionOne-cards-list-row a.five {
  margin-top: 15px;
  height: 250px;
  position: relative;
  background-color: #e57d21;
}
.ResourcesSectionOne .ResourcesSectionOne-cards-list .ResourcesSectionOne-cards-list-row a.five img {
  right: 20px;
}
.ResourcesSectionOne .ResourcesSectionOne-cards-list .ResourcesSectionOne-cards-list-row a.six {
  margin-top: -85px;
  height: 350px;
  position: relative;
  background-color: #9b56b6;
}
.ResourcesSectionOne .ResourcesSectionOne-cards-list .ResourcesSectionOne-cards-list-row a.six img {
  right: 20px;
}
.ResourcesSectionOne .ResourcesSectionOne-cards-list .ResourcesSectionOne-cards-list-row a h2 {
  font-size: 25px;
  font-weight: bold;
  color: #ffffff;
  margin-bottom: 20px;
}
.ResourcesSectionOne .ResourcesSectionOne-cards-list .ResourcesSectionOne-cards-list-row a p {
  font-size: 18px;
  color: #ffffff;
}
.ResourcesSectionOne .ResourcesSectionOne-cards-list .ResourcesSectionOne-cards-list-row a img {
  padding: 6.5px;
  width: 10%;
  height: auto;
  border: 3px solid white;
  border-radius: 4px;
  position: absolute;
  bottom: 20px;
}
.ResourcesSectionOne .ResourcesSectionOne-cards-list .one:hover, .ResourcesSectionOne .ResourcesSectionOne-cards-list .two:hover, .ResourcesSectionOne .ResourcesSectionOne-cards-list .three:hover, .ResourcesSectionOne .ResourcesSectionOne-cards-list .four:hover, .ResourcesSectionOne .ResourcesSectionOne-cards-list .five:hover, .ResourcesSectionOne .ResourcesSectionOne-cards-list .six:hover {
  filter: brightness(0.75);
  transform: scale(1.05);
}`, "",{"version":3,"sources":["webpack://./src/components/Resourses/SectionOne/SectionOne.scss"],"names":[],"mappings":"AAAA;EACC,WAAA;EACA,8BAAA;EACA,cAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,eAAA;EACA,mBAAA;EACG,gBAAA;AACJ;AACC;EACC,mBAAA;EACG,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;AACL;AAEC;EACC,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;EACA,WAAA;AAAF;AAGC;EACC,aAAA;EACA,sBAAA;EACA,gBAAA;AADF;AAGE;EACC,aAAA;EACA,SAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;AADH;AAGG;EACC,aAAA;EACA,sBAAA;EACA,YAAA;EACA,yBAAA;EACA,mBAAA;EACA,aAAA;EACA,4BAAA;AADJ;AAII;EACC,aAAA;EACA,kBAAA;EACA,yBAAA;AAFL;AAGK;EACC,WAAA;AADN;AAKI;EACC,aAAA;EACA,kBAAA;EACA,yBAAA;AAHL;AAIK;EACC,WAAA;AAFN;AAMI;EACC,aAAA;EACA,kBAAA;EACA,yBAAA;AAJL;AAKK;EACC,WAAA;AAHN;AAOI;EACC,iBAAA;EACA,aAAA;EACA,kBAAA;EACA,yBAAA;AALL;AAMK;EACC,WAAA;AAJN;AAQI;EACC,gBAAA;EACA,aAAA;EACA,kBAAA;EACA,yBAAA;AANL;AAOK;EACC,WAAA;AALN;AASI;EACC,iBAAA;EACA,aAAA;EACA,kBAAA;EACA,yBAAA;AAPL;AAQK;EACC,WAAA;AANN;AAUI;EACC,eAAA;EACA,iBAAA;EACA,cAAA;EACA,mBAAA;AARL;AAUI;EACC,eAAA;EACA,cAAA;AARL;AAWI;EACC,cAAA;EACA,UAAA;EACA,YAAA;EACA,uBAAA;EACA,kBAAA;EACA,kBAAA;EACA,YAAA;AATL;AAcE;EACC,wBAAA;EAEA,sBAAA;AAZH","sourcesContent":[".ResourcesSectionOne {\n\twidth: 100%;\n\tbackground: rgba(249,249,249,255);\n\tcolor: #000000;\n\tdisplay: flex;\n\tflex-direction: column;\n\tposition: relative;\n\tfont-size: 18px;\n\tpadding: 80px 175px;\n    margin-top: 50px;\n\n\t.ResourcesSectionOne-header {\n\t\tfont-family: Roboto;\n\t    font-style: normal;\n\t    font-weight: 400;\n\t    font-size: 43px;\n\t    line-height: 1.3;\n\t    color: #1c2640;\n\t    margin-bottom: 30px;\n\t}\n\n\t.ResourcesSectionOne-sub-header {\n\t\tfont-size: 18px;\n\t\tfont-weight: 400;\n\t\tline-height: 1.6;\n\t\tcolor: #1c2640;\n\t\twidth: 100%;\n\t}\n\n\t.ResourcesSectionOne-cards-list {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tmargin-top: 40px;\n\n\t\t.ResourcesSectionOne-cards-list-row {\n\t\t\tdisplay: flex;\n\t\t\tflex: 1;\n\t\t\tflex-direction: row;\n\t\t\tjustify-content: space-between;\n\t\t\tmargin-bottom: 20px;\n\n\t\t\ta {\n\t\t\t\tdisplay: flex;\n\t\t\t\tflex-direction: column;\n\t\t\t\twidth: 31.5%;\n\t\t\t\tbackground-color: #000000;\n\t\t\t\tborder-radius: 15px;\n\t\t\t\tpadding: 30px;\n\t\t\t\ttransition: all 0.3s ease 0s;\n\t\t\t\t// margin: 10px;\n\n\t\t\t\t&.one {\n\t\t\t\t\theight: 250px;\n\t\t\t\t\tposition: relative;\n\t\t\t\t\tbackground-color: #2c95dd;\n\t\t\t\t\timg {\n\t\t\t\t\t\tright: 20px;\n\t\t\t\t\t}\n\t\t\t\t}\n\n\t\t\t\t&.two {\n\t\t\t\t\theight: 350px;\n\t\t\t\t\tposition: relative;\n\t\t\t\t\tbackground-color: #f84144;\n\t\t\t\t\timg {\n\t\t\t\t\t\tright: 20px;\n\t\t\t\t\t}\n\t\t\t\t}\n\n\t\t\t\t&.three {\n\t\t\t\t\theight: 250px;\n\t\t\t\t\tposition: relative;\n\t\t\t\t\tbackground-color: #173a87;\n\t\t\t\t\timg {\n\t\t\t\t\t\tright: 20px;\n\t\t\t\t\t}\n\t\t\t\t}\n\n\t\t\t\t&.four {\n\t\t\t\t\tmargin-top: -85px;\n\t\t\t\t\theight: 350px;\n\t\t\t\t\tposition: relative;\n\t\t\t\t\tbackground-color: #27ad60;\n\t\t\t\t\timg {\n\t\t\t\t\t\tright: 20px;\n\t\t\t\t\t}\n\t\t\t\t}\n\n\t\t\t\t&.five {\n\t\t\t\t\tmargin-top: 15px;\n\t\t\t\t\theight: 250px;\n\t\t\t\t\tposition: relative;\n\t\t\t\t\tbackground-color: #e57d21;\n\t\t\t\t\timg {\n\t\t\t\t\t\tright: 20px;\n\t\t\t\t\t}\n\t\t\t\t}\n\n\t\t\t\t&.six {\n\t\t\t\t\tmargin-top: -85px;\n\t\t\t\t\theight: 350px;\n\t\t\t\t\tposition: relative;\n\t\t\t\t\tbackground-color: #9b56b6;\n\t\t\t\t\timg {\n\t\t\t\t\t\tright: 20px;\n\t\t\t\t\t}\n\t\t\t\t}\n\n\t\t\t\th2 {\n\t\t\t\t\tfont-size: 25px;\n\t\t\t\t\tfont-weight: bold;\n\t\t\t\t\tcolor: #ffffff;\n\t\t\t\t\tmargin-bottom: 20px;\n\t\t\t\t}\n\t\t\t\tp {\n\t\t\t\t\tfont-size: 18px;\n\t\t\t\t\tcolor: #ffffff;\n\t\t\t\t}\n\n\t\t\t\timg {\n\t\t\t\t\tpadding: 6.5px;\n\t\t\t\t\twidth: 10%;\n\t\t\t\t\theight: auto;\n\t\t\t\t\tborder: 3px solid white;\n\t\t\t\t\tborder-radius: 4px;\n\t\t\t\t\tposition: absolute;\n\t\t\t\t\tbottom: 20px;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\n\t\t.one:hover, .two:hover, .three:hover, .four:hover, .five:hover, .six:hover {\n\t\t\tfilter: brightness(0.75);\n\t\t\t-webkit-transform: scale(1.05);\n\t\t\ttransform: scale(1.05);\n\t\t}\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
